import { type ComponentProps } from 'react'

import { Skeleton } from '~/domains/platform/design-system/skeleton/skeleton'

export function SkeletonLoader({
  isLoading,
  size = 1,
  ...rest
}: { isLoading: boolean; size?: number } & ComponentProps<typeof Skeleton>) {
  if (!isLoading) return null

  return (
    <>
      {Array.from({ length: size }).map((_, idx) => (
        <Skeleton key={idx} width="calc(100% - 2.5rem)" height="3.375rem" ml="1.25rem" {...rest} />
      ))}
    </>
  )
}
